import React, { useEffect } from 'react';

import ModalPortal from '../components/modal-portal';
import ScoringMatchEntry from './scoring-match-entry';
import type { MatchItem, ScoringSystem } from './scoring-types';

interface Props {
  match: MatchItem;
  token: string;
  canSubmit: boolean;
  scoring?: ScoringSystem;
  // Do ilu i jak gramy — ta sama linia, co nad tabelą grupy. W oknie nie widać
  // nagłówka strony, a wpisujący musi wiedzieć, czy set kończy się na 21 czy 30.
  formatLabel: string;
  big?: boolean;
  onClose: () => void;
  onSaved: () => void;
}

export const ScoringMatchModal: React.FC<Props> = ({
  match,
  token,
  canSubmit,
  scoring,
  formatLabel,
  big = false,
  onClose,
  onSaved,
}) => {
  useEffect(() => {
    function onKeyDown(event: KeyboardEvent): void {
      if (event.key === 'Escape') {
        onClose();
      }
    }

    document.addEventListener('keydown', onKeyDown);

    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  return (
    <ModalPortal>
      <div className="scoring-modal__backdrop" data-testid="scoring-match-modal" onClick={onClose}>
        <div
          role="dialog"
          aria-modal="true"
          aria-label={`Wynik meczu — ${match.player1Name} vs ${match.player2Name}`}
          className={big ? 'scoring-modal scoring-modal--big' : 'scoring-modal'}
          onClick={(event) => event.stopPropagation()}
        >
          <header className="scoring-modal__head">
            <h3 className="scoring-modal__title">Wynik meczu</h3>
            <button
              type="button"
              className="scoring-modal__close"
              data-testid="scoring-match-modal-close"
              aria-label="Zamknij"
              onClick={onClose}
            >
              ✕
            </button>
          </header>

          <p className="scoring-modal__rules" data-testid="scoring-match-modal-rules">
            {formatLabel}
          </p>

          <ScoringMatchEntry
            match={match}
            token={token}
            canSubmit={canSubmit}
            scoring={scoring}
            cancelLabel="Anuluj"
            onSaved={onSaved}
            onCancel={onClose}
          />
        </div>
      </div>
    </ModalPortal>
  );
};

export default ScoringMatchModal;
